// extracted by mini-css-extract-plugin
module.exports = {"graphBuilderContextMenu":"GraphBuilderContextMenu_graphBuilderContextMenu__1sk6W","menuHeading":"GraphBuilderContextMenu_menuHeading__cI9PB"};